import type React from 'react';
import type {z} from 'zod';
import type {
  ParagraphSchema,
  ParagraphsSchema,
} from '../../../../../core/entities/companyDetail/schema';
import {useWindowSize} from '../../../../../shared/services/useWindowSize';
import {replaceIframeDimensions} from '../../../usecase/replaceIframeDimensions';
import {SectionTitle} from './SectionTitle';

type Props = {
  companyPageSharedParagraph?: z.infer<typeof ParagraphsSchema>;
  title: string;
  description?: string;
  isPC: boolean;
};

export const CompanyIntroduction: React.FC<Props> = ({
  companyPageSharedParagraph,
  title,
  description,
  isPC,
}) => {
  const {width} = useWindowSize();

  return (
    <div>
      <SectionTitle id="introduction" sectionTitle={title} />
      {companyPageSharedParagraph ? (
        <div className="pc:mt-8 py-12 px-16 pc:py-24 pc:px-[250px] bg-white rounded-b-[12px] rounded-t-[4px] border-t-[1px] border-solid border-t-line-1 pc:border-t-[0px]">
          {companyPageSharedParagraph.map(
            (paragraph: z.infer<typeof ParagraphSchema>, i: number) => {
              const {photoURL} = paragraph;
              return (
                <div key={paragraph.title}>
                  {i > 0 && <hr className="mt-32" />}
                  <h3
                    className={`font-bold leading-none ${i === 0 ? 'mt-8' : 'mt-[32px]'}`}
                  >
                    {paragraph.title}
                  </h3>
                  <div
                    className="mt-12"
                    dangerouslySetInnerHTML={{
                      __html: isPC
                        ? (paragraph.description ?? '').replaceAll('\n', '<br>')
                        : replaceIframeDimensions(
                            (paragraph.description ?? '').replaceAll(
                              '\n',
                              '<br>',
                            ),
                            width,
                          ),
                    }}
                  />
                  <div>
                    {photoURL && (
                      <img
                        src={photoURL}
                        alt={paragraph.photoCaption || ''}
                        className="pc:w-full"
                      />
                    )}
                  </div>
                  {paragraph.photoCaption && (
                    <div>{paragraph.photoCaption}</div>
                  )}
                </div>
              );
            },
          )}
        </div>
      ) : (
        description && (
          <div>
            {/* 社内で入稿したもののみ、HTMLを解釈できるようにする */}
            <div
              className="mt-8 p-24 bg-white rounded-b-[12px]"
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
          </div>
        )
      )}
    </div>
  );
};
